











import StatementsTable from "@/components/elements/statement/StatementsTable.vue";
import Filters from "@/components/elements/statement/Filters.vue";
import {Component, Vue} from "vue-property-decorator";

@Component({
  components: {Filters, StatementsTable},
  validations() {
    return {
      form: {
        dateFilter: {},
      }
    }
  },
  data: () => ({
  })
})
export default class MyStatements extends Vue {
  onFilterByNumber() {
  }


}
